import { render, staticRenderFns } from "./LandingHeader.vue?vue&type=template&id=1ffe1ede&scoped=true"
import script from "./LandingHeader.vue?vue&type=script&lang=js"
export * from "./LandingHeader.vue?vue&type=script&lang=js"
import style0 from "./LandingHeader.vue?vue&type=style&index=0&id=1ffe1ede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffe1ede",
  null
  
)

export default component.exports